import { OfferDemandDataModel } from '../../../types/indicators.interfaces';
import { HalfPageModule, SectionTitle } from '../../../styles/global.styles';
import {
  OfferDemandContainer,
  OfferDemandGraphContainer,
  OfferDemandLegendContainer,
  OfferDemandLegendDot,
  OfferDemandLegendLabel,
  OfferDemandNoData,
} from './offerDemand.styles';
import { OfferDemandGraph } from './offerDemandGraph.component';
import { OfferDemandInfo } from './offerDemandInfo.component';
import { useIntl } from 'react-intl';
import noData from '../../../assets/images/error.png';

export const OfferDemand = (props: OfferDemandDataModel) => {
  const intl = useIntl();
  return (
    <HalfPageModule>
      <SectionTitle>
        {intl.formatMessage({ id: 'offerDemand.title' })}
      </SectionTitle>
      <OfferDemandContainer>
        <OfferDemandLegendContainer>
          <OfferDemandLegendLabel>
            <OfferDemandLegendDot color={'#B6BBC6'} />{' '}
            {intl.formatMessage({
              id: `glossary.supply_and_demand.supply.title`,
            })}
          </OfferDemandLegendLabel>
          <OfferDemandLegendLabel>
            <OfferDemandLegendDot color={'#363C4B'} />{' '}
            {intl.formatMessage({
              id: `glossary.supply_and_demand.demand.title`,
            })}
          </OfferDemandLegendLabel>
        </OfferDemandLegendContainer>
        {props &&
        props.categories &&
        props.categories.length > 0 &&
        props.categories.some((cat) => cat.demand !== 0 || cat.offer !== 0) ? (
          <OfferDemandGraph {...props} />
        ) : (
          <OfferDemandGraphContainer>
            <OfferDemandNoData>
              {intl.formatMessage({ id: 'offerDemand.noDataForGraph' })}
              <img src={noData} alt="no data" width={70} />
            </OfferDemandNoData>
          </OfferDemandGraphContainer>
        )}
        <OfferDemandInfo {...props} />
      </OfferDemandContainer>
    </HalfPageModule>
  );
};
